import { styled } from "styled-components";

const TightWrapper = styled.div`
    width: fit-content;
    margin: auto;
`;

export default TightWrapper;